import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { BASE_URL } from "../Constants";
import "./css/Nav.css";
import logo from "./images/gangadwar_web_logo.webp";
import NavbarSearch from "./NavBarSearch";

const fetchSubcategories = async () => {
  const response = await axios.get(`${BASE_URL}/api/subcategory/getNav`);
  return response.data;
};

const NavBarComponent = () => {
  const { data: subcategories = [], isLoading, isError } = useQuery(
    "subcategories",
    fetchSubcategories
  );
  const [expanded, setExpanded] = useState(false);

  const handleSearchComplete = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      expand="lg"
      collapseOnSelect
      expanded={expanded}
      className="site-navbar"
    >
      <Container fluid className="site-navbar-container">
        <Navbar.Brand
          as={Link}
          to="/"
          className="brand-link"
          onClick={() => setExpanded(false)}
        >
          <img
            src={logo}
            alt="Gangadwar"
            className="navlogo"
            width="56"
            height="56"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <span className="brand-copy">
            <span className="brand-title-en">Gangadwar Bhajnawali</span>
            <span className="brand-title-hi">गंगाद्वार भजनावली</span>
          </span>
        </Navbar.Brand>

        <div className="navbar-search-wrap navbar-search-wrap-visible">
          <NavbarSearch onSearchComplete={handleSearchComplete} />
        </div>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="navbar-toggle-custom"
          onClick={() => setExpanded(!expanded)}
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav-links-group">
            <Nav.Link
              as={Link}
              to="/"
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              Home / होम
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/page/about-us"
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              About / हमारे बारे में
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/feedback"
              className="nav-link-custom"
              onClick={() => setExpanded(false)}
            >
              Feedback / सुझाव
            </Nav.Link>

            <NavDropdown
              title="Bhajans / भजन"
              id="basic-nav-dropdown"
              className="nav-dropdown-custom"
            >
              {isLoading && (
                <NavDropdown.Item disabled>Loading bhajans...</NavDropdown.Item>
              )}

              {isError && (
                <NavDropdown.Item disabled>
                  Unable to load bhajans
                </NavDropdown.Item>
              )}

              {!isLoading &&
                !isError &&
                subcategories.map((subcategory) => (
                  <NavDropdown.Item
                    as={Link}
                    key={subcategory.subCategoryId}
                    to={`/subcategory/${subcategory.subCategoryId}`}
                    state={{ resetScroll: true }}
                    onClick={() => setExpanded(false)}
                  >
                    {subcategory.titlePrimary}
                  </NavDropdown.Item>
                ))}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBarComponent;
